import { render, staticRenderFns } from "./GallerySlide.vue?vue&type=template&id=0882e767&scoped=true&"
import script from "./GallerySlide.vue?vue&type=script&lang=js&"
export * from "./GallerySlide.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlide.vue?vue&type=style&index=0&id=0882e767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882e767",
  null
  
)

export default component.exports